import styled from "styled-components";

import { MapLibreMapHost } from "@ryde/controls";
import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";

/**
 * The station-chooser map.
 *
 * No top margin: it sits in a .landing-address-map-field wrapper that is a fixed height with its overflow
 * hidden, so pushing the map down inside it simply cuts the same amount off the bottom — which is where
 * the attribution sits. The Google map carried a 20px inline margin here and lost its bottom edge the
 * same way.
 */
export const LandingAddressMapStyled = styled(
  MapLibreMapHost,
).attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "landing-address-map",
})<{ $width: string; $height: string }>`
  width: ${({ $width }) => $width};
  height: ${({ $height }) => $height};

  /*
   * Both markers here are clickable and open a label. The station pin normally gets its cursor from the
   * zero-size wrapper that MapLibreStationPinMarker adds, and the home icon is a bare element, so neither
   * has one on this map — Google put a pointer on every marker it drew.
   */
  & .maplibregl-marker {
    cursor: pointer;
  }
`;
